import request from '@/utils/request'
import { getApiBaseUrl, getGCPStorageUrl } from "./index";
import axios from 'axios'
import { getToken } from '../utils/auth'

export function getGCPFileUrl(filename) {
  return getGCPStorageUrl() + '/' + filename
  // if (process.env.NODE_ENV === 'production') {
  //   return getGCPStorageUrl() + '/' + filename
  // } else if (filename.includes('/')) {
  //   return getApiBaseUrl() + '/' + filename
  // } else {
  //   return getApiBaseUrl() + '/api/attachments/tfam-storage/download/' + filename
  // }
}

export function storageUploadFiles(files) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('file', files[i], files[i].name)
  }
  const baseAPI = getApiBaseUrl() + '/api/attachments/tfam-storage/upload?access_token=' + getToken();
  return axios.post(baseAPI, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
